import { useEffect, useState } from "react";

import { getAPIPayload } from "../../../apis/getApi";
import { clientShouldWaitForAgent } from "./carOwnerAgentWait";

export { clientShouldWaitForAgent };

let cached = undefined;
let pending = null;

export const loadCarOwnerAgentWait = () => {
  if (cached !== undefined) {
    return Promise.resolve(cached);
  }
  if (!pending) {
    pending = getAPIPayload({
      url: "car-owner-waiting",
      data: {},
      token: true,
    })
      .then((response) => {
        cached =
          response?.success && response?.data?.waiting_on_agent
            ? response.data
            : false;
        return cached;
      })
      .catch(() => {
        cached = false;
        return cached;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};

export const useCarOwnerAgentWait = () => {
  const [status, setStatus] = useState(
    cached === undefined ? null : cached,
  );

  useEffect(() => {
    let cancelled = false;
    loadCarOwnerAgentWait().then((value) => {
      if (!cancelled) {
        setStatus(value);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
};
